import Row from './row';
import Col from './col';

export default { Row, Col };
